import {
  CREATE_MANPOWER_SUCCESS,
  FETCH_MANPOWER_SUCCESS,
  GET_MANPOWER_FROM_JOB_ALLOCATION,
  GET_MANPOWER_SUCCESS,
  SAVE_MANPOWER_QUERY,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  manpowerList: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_MANPOWER_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_MANPOWER_SUCCESS: {
      const query = {...state.query};
      if(query && query.pagination)
        query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case GET_MANPOWER_FROM_JOB_ALLOCATION: {
      return {
        ...state,
        manpowerList: action.data,
      };
    }

    case CREATE_MANPOWER_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_MANPOWER_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }


    default:
      return state;
  }
}
